export default __webpack_public_path__ + "static/Rubik-61c407a14e6980195a7768b32e064d3a.woff2";